import CodeBlock from '@/components/content/CodeBlock'
import Details from '@/components/content/Details'
import { PRICING_DATABASE_URI } from '@/utils/pricing-database'

export default function PricingDatabaseCallout() {
  return (
    <div id='pricing-database' className='mb-3 max-w-full min-w-0 border border-blue-600 p-3 dark:border-blue-500'>
      <p>
        You and your agent can query Vitess, Neki, and Postgres cluster pricing using SQL. Instructions and an
        agent-friendly version of the available catalog are in <a href='/pricing.md'>pricing.md</a>.
      </p>
      <Details summary='Connect to pricing database'>
        <div className='mt-2'>
          <p>
            Role: <code>SELECT</code> only on <code>public.planetscale_prices</code>. SSL is required.
          </p>
          <p>Copy the URI and connect with any Postgres client:</p>
          <CodeBlock
            clipboard
            code={PRICING_DATABASE_URI}
            html={`<pre class="shiki whitespace-pre-wrap break-all"><code>${PRICING_DATABASE_URI.replaceAll('&', '&amp;')}</code></pre>`}
          />
          <p>
            Example queries and the available catalog are in <a href='/pricing.md'>pricing.md</a>.
          </p>
        </div>
      </Details>
    </div>
  )
}
